import { clearExpiredProducts, promoteChildToParent, registerInstantProducts, updateInstantProductsQuery, } from './instant-products-actions.js';
import { instantProductsReducer as instantProducts } from './instant-products-slice.js';
/**
 * Loads the commerce instant products reducer and returns the available instant products actions.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the instant products action creators.
 *
 * @group Actions
 * @category InstantProducts
 */
export function loadInstantProductsActions(engine) {
    engine.addReducers({ instantProducts });
    return {
        clearExpiredProducts,
        promoteChildToParent,
        registerInstantProducts,
        updateInstantProductsQuery,
    };
}
